import React, {useState, useEffect} from 'react';
import Details from './Details';
import Plan from './Plan';
import Integrations from './Integrations';
import NavBar from './NavBar';
import MobileNavBar from './MobileNavBar';
import AlertSettings from './AlertSettings';
import {toast} from 'react-toastify';
import {getProfile} from 'utils/api/authApi';
import './style.scss';
import {useHistory} from 'react-router-dom';

export default function Account(props) {
    let history = useHistory();

    const [mode, handleMode] = useState('General');
    const [profile, setProfile] = useState(null);
    const [fetchingProfileData, setFetchingProfileData] = useState(true);

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async() => {
        try {
            let profileData = await getProfile();
            setProfile(profileData.content);
            fetchingProfileData && setFetchingProfileData(false);
        } catch(err) {
            console.log(err);
            if(err.message && err.message.length < 150) {
                toast.error(err.message);
            }
            setFetchingProfileData(false);
        }
    };

    const handleActiveTab = () => {
        switch(mode) {
            case 'General': {
                return <Details history={history} profile={profile} refreshProfile={fetchProfile}/>;
            }
            case 'Integrations': {
                return <Integrations history={history} profile={profile} refreshProfile={fetchProfile}/>;
            }
            case 'Plan': {
                return <Plan history={history} profile={profile} refreshProfile={fetchProfile}/>;
            }
            case 'Alerts Settings': {
                return <AlertSettings profile={profile} refreshProfile={fetchProfile}/>;
            }
            default:
                return <Details history={history} profile={profile} refreshProfile={fetchProfile}/>;
        }
    };

    return (
        <div className="account mt-3">
            <h1 className="mt-3">Settings</h1>
            {window.innerWidth > 590 ? (
                <NavBar active={mode} handleMode={handleMode}/>
            ) : (
                <MobileNavBar handleMode={handleMode}/>
            )}
            {handleActiveTab()}
            {/* <span>
                Need help? Please contact us at{' '}
                <a href="mailto:support@ozmosys.com">support@ozmosys.com</a>
            </span> */}
        </div>
    );
}
